import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const partialUpdateDonationSettings = async (
  params: Partial<DonationSettingsResponse>
) => {
  const { body } =
    await api.patch<DonationSettingsResponse>(
      "/donation-settings/",
      { body: params }
    )
  queryClient.setQueryData(
    [BASE_DONATION_SETTINGS_QUERY_KEY],
    body
  )
  return body
}
